// @ts-nocheck
export default defineNuxtPlugin(nuxtApp => {
  if (useRuntimeConfig().public.stage !== 'live') {
    window.app = useNuxtApp()
    nuxtApp.hook('app:mounted', () => {
      window.document.body.classList.add('mounted')
    })
  }
})
